import { render, staticRenderFns } from "./WPCheckCalculationBtns.vue?vue&type=template&id=771c8977"
import script from "./WPCheckCalculationBtns.vue?vue&type=script&lang=ts"
export * from "./WPCheckCalculationBtns.vue?vue&type=script&lang=ts"
import style0 from "./WPCheckCalculationBtns.vue?vue&type=style&index=0&id=771c8977&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports